import React from 'react';
import './Header.css';

function Header({ currentPage, onNavigate }) {
  return (
    <header className="app-header-nav">
      <div className="header-container">
        <div className="logo-section-header" onClick={() => onNavigate('home')}>
          <span className="logo-icon-header">🐱</span>
          <span className="logo-text">喵喵合唱团</span>
        </div>

        <nav className="nav-menu">
          <button
            className={`nav-item ${currentPage === 'home' ? 'active' : ''}`}
            onClick={() => onNavigate('home')}
          >
            <span className="nav-icon">🏠</span>
            <span className="nav-label">首页</span>
          </button>

          <button
            className={`nav-item ${currentPage === 'editor' ? 'active' : ''}`}
            onClick={() => onNavigate('editor')}
          >
            <span className="nav-icon">🎹</span>
            <span className="nav-label">编辑器</span>
          </button>

          <button
            className={`nav-item ${currentPage === 'docs-zh' ? 'active' : ''}`}
            onClick={() => onNavigate('docs-zh')}
          >
            <span className="nav-icon">📖</span>
            <span className="nav-label">中文文档</span>
          </button>

          <button
            className={`nav-item ${currentPage === 'docs-en' ? 'active' : ''}`}
            onClick={() => onNavigate('docs-en')}
          >
            <span className="nav-icon">📘</span>
            <span className="nav-label">English</span>
          </button>
        </nav>
      </div>
    </header>
  );
}

export default Header;

